var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 1.99955C11.5083 1.82445 11.7162 1.68556 11.945 1.5908C12.1738 1.49604 12.419 1.44727 12.6666 1.44727C12.9142 1.44727 13.1594 1.49604 13.3882 1.5908C13.617 1.68556 13.8248 1.82445 13.9999 1.99955C14.175 2.17465 14.3139 2.38252 14.4087 2.61129C14.5034 2.84006 14.5522 3.08526 14.5522 3.33288C14.5522 3.58051 14.5034 3.8257 14.4087 4.05448C14.3139 4.28325 14.175 4.49112 13.9999 4.66622L4.99992 13.6662L1.33325 14.6662L2.33325 10.9996L11.3333 1.99955Z",
    stroke: "#C7C9D9",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.46c1691ad82e608cb6fc94ee89fddcbe.svg";
export { ForwardRef as ReactComponent };